import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Box, Container, Typography, useMediaQuery, useTheme } from '@mui/material'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function ListObjectifs({ fetchObjectifs, objectifs, setSelectedRows }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [modifiedColumns, setModifiedColumns] = useState([])

  const siteUser = useSelector((store) => store.user)

  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchObjectifs(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchObjectifs(url)
  }

  useEffect(() => {
    // setTTs(!tts)
    if (isMobile) {
      setModifiedColumns([
        {
          field: 'objectives_name',
          headerName: t('mesObjectifs.colNameObjective'),
          width: 190,
          renderCell: (params) => (
            <Box py={2} mt={1}>
              <Box fontWeight={600}>{params.row.objectives_name}</Box>
              <Box>
                <Box component={'span'}>{t('mesObjectifs.dateOfObjectiveColon')}</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {convertToUserDateFormate(siteUser.user, params.row.date_objectives)}
                </Box>
              </Box>
              <Box>
                <Box component={'span'}>{t('mesObjectifs.dueDateColon')}</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {convertToUserDateFormate(siteUser.user, params.row.date_echeance)}
                </Box>
              </Box>
              <Box>
                <Box component={'span'}>{t('mesObjectifs.domainColon')}</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.domain}
                </Box>
              </Box>
            </Box>
          ),
        },
        {
          field: 'objectifs',
          headerName: t('mesObjectifs.colObjectives'),
          width: 70,
          renderCell: (params) => (
            <Box py={2}>
              <Box component={'span'} fontWeight={600}>
                {params.row.objectifs}
              </Box>
            </Box>
          ),
        },
        {
          field: 'status',
          headerName: t('mesObjectifs.colStatus'),
          width: 110,
          renderCell: (params) => (
            <Box py={2}>
              {params.row.status === 'En cours' ? (
                <span
                  style={{
                    backgroundColor: '#FFEF00',
                    borderRadius: '10px',
                    padding: '5px',
                  }}
                >
                  {t('mesObjectifs.statusInProgress')}
                </span>
              ) : params.row.status === 'Annulé' ? (
                <span
                  style={{
                    backgroundColor: 'red',
                    borderRadius: '10px',
                    color: 'white',
                    padding: '5px',
                  }}
                >
                  {t('mesObjectifs.statusCancelled')}
                </span>
              ) : params.row.status === 'reussite' ? (
                <span
                  style={{
                    backgroundColor: 'green',
                    borderRadius: '10px',
                    padding: '5px',
                  }}
                >
                  {t('mesObjectifs.statusAchieved')}
                </span>
              ) : (
                t('mesObjectifs.notAvailable')
              )}
            </Box>
          ),
        },
      ])
    } else {
      setModifiedColumns(columns)
    }
  }, [isMobile])
  const columns = [
    //   { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'domain',
      headerName: t('mesObjectifs.colDomain'),
      width: 150,
      editable: true,
    },
    {
      field: 'objectives_name',
      headerName: t('mesObjectifs.colNameObjective'),
      width: 250,
      editable: true,
      renderCell: (params) => params.row.objectives_name,
    },
    {
      field: 'objectifs',
      headerName: t('mesObjectifs.colObjectives'),
      width: 150,
      renderCell: (params) => params.row.objectifs,
    },
    {
      field: 'date_objectives',
      headerName: t('mesObjectifs.colDateOfObjective'),
      width: 200,
      renderCell: (params) => convertToUserDateFormate(siteUser.user, params.row.date_objectives),
    },
    {
      field: 'date_echeance',
      headerName: t('mesObjectifs.colDueDate'),
      width: 200,
      renderCell: (params) => convertToUserDateFormate(siteUser.user, params.row.date_echeance),
    },
    {
      field: 'periodicity',
      headerName: t('mesObjectifs.colPeriodicity'),
      width: 100,
      editable: true,
    },
    {
      field: 'status',
      headerName: t('mesObjectifs.colStatus'),
      width: 180,
      editable: true,
      renderCell: (params) => (
        <>
          {params.row.status === 'En cours' ? (
            <span
              style={{
                backgroundColor: '#FFEF00',
                borderRadius: '10px',
                padding: '5px',
              }}
            >
              {t('mesObjectifs.statusInProgress')}
            </span>
          ) : params.row.status === 'Annulé' ? (
            <span
              style={{
                backgroundColor: 'red',
                borderRadius: '10px',
                color: 'white',
                padding: '5px',
              }}
            >
              {t('mesObjectifs.statusCancelled')}
            </span>
          ) : params.row.status === 'reussite' ? (
            <span
              style={{
                backgroundColor: 'green',
                borderRadius: '10px',
                padding: '5px',
              }}
            >
              {t('mesObjectifs.statusAchieved')}
            </span>
          ) : (
            t('mesObjectifs.notAvailable')
          )}
        </>
      ),
    },
    {
      field: 'reached',
      headerName: t('mesObjectifs.colProgress'),
      sortable: false,
      width: 180,
    },
  ]
  return (
    <div
      style={{
        height: 800,
        width: '100%',
        background: 'white',
        borderRadius: '5px',
        paddingBottom: 54,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        {t('mesObjectifs.pageTitle')} ({objectifs.count})
      </Typography>
      <DataGrid
        rows={objectifs.results ? objectifs.results : []}
        columns={modifiedColumns}
        pageSize={rows}
        getRowHeight={() => (isMobile ? 'auto' : 50)}
        rowCount={objectifs.count ? objectifs.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        checkboxSelection
      />
    </div>
  )
}
export default ListObjectifs
